export default __webpack_public_path__ + "static/media/analytics.beac7e05.svg";